import React, { useEffect, useState, memo } from 'react';
import { Button, Card, Empty, Space, Input } from 'antd';
import { CodeOutlined, EyeOutlined } from '@ant-design/icons';
import { StatusIcon } from '../Icons';

const { TextArea } = Input;

const replaceTemplateVariables = (html, variables) => {
    if (!html) return "";
    return html.replace(/{{\s*([\w]+)\s*}}/g, (match, p1) => {
        return variables.hasOwnProperty(p1.trim()) ? variables[p1.trim()] : match;
    });
};

const TemplatePreview = memo(({
    html = "",
    variables = {},
    title = "",
    message = "",
    status = "info",
    setValue,
    editHtml = false,
}:any) => {
    const [htmlContent, setHtmlContent] = useState("");
    const [editedHtml, setEditedHtml] = useState(html);
    const [isPreview, setIsPreview] = useState(true);

    useEffect(() => {
        setEditedHtml(html);
        setHtmlContent(replaceTemplateVariables(html, variables));
    }, [html, variables]);

    const handleReset = () => {
        setEditedHtml(html);
        setHtmlContent(replaceTemplateVariables(html, variables));
    };

    useEffect(() => {
        if (htmlContent.trim()) {
            setValue("data[html]", htmlContent);
        }
    }, [htmlContent, setValue]);

    const statusConfig = {
        info: { icon: <StatusIcon.info />, iconText: "Info" },
        warn: { icon: <StatusIcon.warn />, iconText: "Warning" },
        success: { icon: <StatusIcon.success />, iconText: "Success" },
        failed: { icon: <StatusIcon.failed />, iconText: "Failed" },
    };

    const { icon } = statusConfig[status] || statusConfig.info;

    return (
        <Card style={{ margin: '20px', borderRadius: '13px', minHeight: '500px', backgroundColor: "rgb(233 235 241)", border: "dashed #18446133" }}>
            {editHtml && (
                <Space style={{ marginBottom: '10px', justifyContent: 'space-between', width: '100%' }}>
                    <Button type="link" onClick={() => setIsPreview(!isPreview)}>
                        {isPreview ? <><CodeOutlined /> Code</> : <><EyeOutlined /> Preview</>}
                    </Button>
                    <Button type="link" onClick={handleReset} disabled={editedHtml === html}>
                        Reset
                    </Button>
                </Space>
            )}

            <div style={{ padding: '30px 22px 22px 20px', borderRadius: '16px', backgroundColor: '#ffffff' }}>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    {icon}
                    <h2 className='preview-title'>{title}</h2>
                    <p className='preview-message'>{message}</p>
                </div>

                <div style={{ minHeight: "300px" }}>
                    {isPreview ? (
                        htmlContent.trim() ? (
                            <div style={{
                                padding: '8px 0px',
                                border: '1px solid #f0f0f0',
                                borderRadius: '12px',
                                backgroundColor: '#F1F1F7',
                                minHeight: '300px',
                                maxHeight: '420px',
                                overflow: 'auto',
                            }}
                                dangerouslySetInnerHTML={{ __html: htmlContent }}
                            />
                        ) : (<Empty
                            description="Please select a template to start editing"
                            style={{
                                backgroundColor: 'rgb(245, 245, 245)',
                                borderRadius: '8px',
                                height: '300px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            }}
                        />)
                    ) : (<TextArea
                        value={editedHtml}
                        onChange={(e) => setEditedHtml(e.target.value)}
                        onBlur={() => setHtmlContent(replaceTemplateVariables(editedHtml, variables))}
                        placeholder="Write your own template Html code </>"
                        style={{
                            borderRadius: '12px',
                            fontFamily: 'monospace',
                            backgroundColor: '#f9f9f9',
                            minHeight: '300px',
                        }}
                    />
                    )}
                </div>

                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <Button type="primary" className="template-close-btn" block size="large">
                        Close
                    </Button>
                </div>

            </div>
        </Card>
    );
}, (prevProps:any, nextProps:any) => {
    // Custom comparison function to avoid unnecessary re-renders
    return (
        prevProps.html === nextProps.html &&
        prevProps.variables === nextProps.variables &&
        prevProps.title === nextProps.title &&
        prevProps.message === nextProps.message &&
        prevProps.status === nextProps.status &&
        prevProps.setValue === nextProps.setValue &&
        prevProps.editHtml === nextProps.editHtml
    );
});

export default TemplatePreview;
